import gsap, { Power3 } from 'gsap';
import { SplitText } from 'gsap/SplitText';
gsap.registerPlugin(SplitText);

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { Functions } from '../_app/cuchillo/utils/Functions';

export default class ScrollItem__InlineTextImages extends VScroll_Item {
  words = [];
  wrapper;

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this.setUpAnimation();

    this.onShow = () => {
      this.showDefault();
    }
  }

  setUpAnimation() {
    const text = GetBy.class('__text', this.item)[0];
    new SplitText(text, { type: "words", wordsClass: 'item --text __item', tag: 'span' }).words;

    this.wrapper = text;

    const all = GetBy.class('__item', this.item);

    for (let i = 0; i < all.length; i++) {
      if (all[i].classList.contains('--text')) {
        this.words.push(new Word(all[i]));
      } else {
        this.words.push(new Img(all[i]));
      }
    }
  }

  showDefault() {
    for (let i = 0; i < this.words.length; i++) {
      gsap.delayedCall(i * .015, () => {
        this.words[i].show();
      });
    }
  }

  resize(w, h) {
    super.resize(w, h);
  }
}

class Word {
  dom;
  classes;

  constructor(__dom) {
    this.dom = __dom;
    __dom.classList.add('--text-anim');
    __dom.classList.add('--lime');
    gsap.set(__dom, { opacity: 0 });
  }

  show() {
    gsap.to(this.dom, { opacity: 1, duration: .3, ease: Power3.easeInOut });
    gsap.delayedCall(.1, () => { this.dom.classList.remove('--lime') });
  }
}

class Img {
  dom;
  classes;

  constructor(__dom) {
    this.dom = __dom;
  }

  show() {
    gsap.delayedCall(.2, () => {
      this.dom.classList.remove('--hide');
    });

    gsap.delayedCall(.6, () => {
      this.dom.classList.remove('--animate');
    });
  }
}

Scroll._registerClass('block-inline-text-images', ScrollItem__InlineTextImages);